import router from '@/router'
import { v4 as uuid } from 'uuid'
import { getRouteNameByStudyTab } from '@/store/router/router'
import { SNK } from '@/helpers/helpers'

const getInitialState = () => ({
  windowId: uuid(),
  bc_notSupported: !('BroadcastChannel' in window),
  bc_channels_info: {
    // bc_app
  },
})

function getBroadcastModule(bc_channels) {
  const getters = {
    bc_notSupported: state => state.bc_notSupported,
    windowId: state => state.bc_notSupported,
    bc_channels_info: state => state.bc_channels_info,
    bc_channels_ids: state => Object.keys(state.bc_channels_info),
  }
  const actions = {
    bc_startChannel({ state, dispatch, commit }, { channelId }) {
      if ('BroadcastChannel' in window) {
        if (!bc_channels[channelId]) {
          bc_channels[channelId] = new BroadcastChannel(channelId)
          bc_channels[channelId].onmessage = message => dispatch('bc_handleMessage', message)
          bc_channels[channelId].onmessageerror = message =>
            dispatch('bc_handleMessageError', message)

          const channelsInfo = {
            ...state.bc_channels_info,
            [channelId]: {
              open: true,
              listeners: [],
            },
          }
          commit('bc_set', { key: 'bc_channels_info', value: channelsInfo })
        }
      }
    },
    bc_updateChannel({ state, commit }, { channelId, message }) {
      // console.log('bc_updateChannel', { channelId, message })
      if (bc_channels[channelId]) {
        const channelsInfo = {
          ...state.bc_channels_info,
          [channelId]: {
            ...state.bc_channels_info[channelId],
            events: [...(state.bc_channels_info[channelId]?.listeners || {}), message.data],
          },
        }
        commit('bc_set', { key: 'bc_channels_info', value: channelsInfo })
      }
    },
    bc_closeChannel({ state, commit }, { channelId }) {
      if (bc_channels[channelId]) {
        bc_channels[channelId].close()
        delete bc_channels[channelId]
        commit('bc_set', {
          key: 'bc_channels',
          value: state.bc_channels.filter(i => i === channelId),
        })
      } else {
        debugger
      }
    },
    bc_postMessage({ commit, state }, { channelId, data }) {
      const channel = bc_channels[channelId]
      if (channel) {
        channel.postMessage({
          ...data,
          windowId: state.windowId,
        })
      }
    },
    bc_handleMessage({ state, commit, dispatch, rootGetters }, message) {
      const { data, target } = message
      const channelId = target.name
      if (data && target) {
        const { code } = data
        if (channelId === 'bc_app') {
          if (code === 'gmf_favorite_ids') {
            commit('gameformat_set', {
              key: 'gameformats_favorite_ids',
              value: data.value,
            })
            return
          }

          if (code === 'gameformats_update') {
            commit('gameformat_set', {
              key: 'gameformats',
              value: data.value,
            })
            return
          }

          if (code === 'settings_udpdate') {
            dispatch('userSettings', {
              ...data.value,
              hasApiUpdate: false,
            })
            return
          }

          if (code === 'app_return_url') {
            dispatch('bc_postMessage', {
              channelId: 'app',
              data: {
                code: 'app_returning_url',
                value: router.currentRoute.value.query,
              },
            })
            return
          }

          if (code === 'logged_in_redirect') {
            dispatch('auth_initFromLocalStorage')
            if (router.currentRoute.value.name === 'Login') {
              dispatch('auth_redirect')
            }
            return
          }
          return
        }

        if (state.bc_channels_info[channelId]) {
          if (code === 'any_update_channel') {
            dispatch('bc_updateChannel', { channelId, message })
            return
          }

          if (code === 'any_window_close') {
            window.close()
            return
          }

          if (code === 'gameformat_set_gameformats_from_gametypes') {
            dispatch('gameformat_set_gameformats_from_gametypes', {
              groups: data.value.groups,
              gametypes: data.value.gametypes,
            })
            return
          }

          if (code === 'any_gmfs_update') {
            const namespace = data.value.namespace || ''
            commit(SNK('gmfs_reset', namespace), data.value.gmfs_state)
            dispatch(SNK('gmfs_checkForRecomputeBase', namespace), {
              gameformat: data.value.gmfs_state.gmfs_gameformat,
              force_recomputeBase: true,
            })

            const pathName = getRouteNameByStudyTab(router, rootGetters)
            if (
              pathName === 'StudySolutions' ||
              pathName === 'StudyReports' ||
              pathName === 'PracticeRangeBuilder'
            ) {
              dispatch('globals_action', 'disable_history_watcher')
              setTimeout(() => {
                dispatch(SNK('gmfs_apply', namespace), {
                  routerParams: {
                    push: false,
                    replace: true,
                    saveLocally: true,
                  },
                  keepHistoryTree: true,
                  hasLists: false,
                  channelId: '',
                })
              }, 0)
            }
            return
          }

          if (code === 'sol_resetCustomSol') {
            const namespace = data.value.namespace || ''
            const { item, routerParams } = data.value
            dispatch(SNK('sol_resetCustomSol', namespace), {
              item,
              routerParams,
            })
            return
          }

          if (code === 'sol_switchSolType') {
            const namespace = data.value.namespace || ''
            const { solType, gmfs_solution_tab } = data.value
            dispatch(SNK('sol_switchSolType', namespace), {
              namespace,
              solType,
              gmfs_solution_tab,
            })
            return
          }

          if (code === 'api_update') {
            const { key, data: l_data } = data.value
            commit('api_update_data', {
              key,
              data: l_data,
            })
            return
          }

          if (code === 'filters_apply') {
            dispatch('filters_apply', {
              id: data.value.id,
              value: data.value.value,
            })
          }
        }
      }
    },
    bc_handleMessageError({ commit }, message) {
      console.log('BC - ERROR', message)
    },
  }

  const mutations = {
    bc_set(state, { key, value }) {
      state[key] = value
    },
  }

  return {
    state: getInitialState(),
    getters,
    actions,
    mutations,
  }
}

export default getBroadcastModule
